import { Http, PageData, PageQuery } from '@mygpt/app/http';

interface ListParams extends PageQuery {
  // 机器人 ID
  datasetId: string;
  search?: string;
}

export interface APIPropertyFunction {
  function_call_name: string;
  function_call_description?: string;
  openapi_url?: string;
  body: string;
  body_required: string;
  request_explanation: string;
  path: string;
  method: string;
  header_authorization?: string;
  server_url: string;
}

export interface APIPropertyItemFunction extends APIPropertyFunction {
  id: string;
  created_at: string;
  updated_at: string;
  dataset_id: string;
}

export const apisServiceFunction = (params: ListParams) => {
  const { datasetId, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<APIPropertyItemFunction>>(`/datasets/${datasetId}/functions`, {
    params: rest,
  });
};
